<template>
  <AutomationResultConfirmModal
      v-if="unskippedAutomations.length > 0"
      @close="onClose"
      @skipped="saveSkippedAutomations"
      :visible="showUnskippedResultConfirmModal"
      :automations="unskippedAutomations"
  />
</template>

<script>
import AutomationResultConfirmModal from "~/pages/automation/components/result/AutomationResultConfirmModal.vue";
import automation from "~/api/automation";

export default {
  name: "UnskippedConfirmModal",
  components: { AutomationResultConfirmModal },
  data() {
    return {
      showUnskippedResultConfirmModal: false,
      unskippedAutomations: []
    };
  },
  created() {
    this.fetchUnskippedAutomations();
  },
  methods: {
    onClose(skippedAutomationIds) {
      automation.skipAutomations(skippedAutomationIds);
      this.showUnskippedResultConfirmModal = false;
    },
    saveSkippedAutomations(skippedAutomationIds) {
      automation.skipAutomations(skippedAutomationIds);
    },
    fetchUnskippedAutomations() {
      this.unskippedAutomations = automation.automationsUnskippedPendingConfirmation([
        'search_thumbnail'
      ]).then((response) => {
        this.unskippedAutomations = response.data;
        if(this.unskippedAutomations.length > 0) {
          this.showUnskippedResultConfirmModal = true;
        }
      });
    },
  }
};
</script>

<style scoped>

</style>
